import { ScrollArea, Stack, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { CreateWellbeingReferralForm } from "@features/wellbeing-referrals/components/CreateWellbeingReferralForm";

export const Route = createFileRoute("/_layout/referrals/wellbeing/create")({
	component: Page,
	staticData: {
		crumb: {
			label: "Request support",
		},
	},
});

function Page() {
	return (
		<ScrollArea
			h="100%"
			className="min-h-0"
			type="always"
			scrollbars="y"
			scrollbarSize={10}
			offsetScrollbars="y"
			styles={{
				scrollbar: { background: "var(--mantine-color-default-hover)" },
				thumb: { background: "var(--mantine-color-gray-6)" },
			}}
            bg="var(--mantine-color-body)"
		>
            <CreateWellbeingReferralForm />
		</ScrollArea>
	);
}
